<template>
  <div id="accommodation-view">
    <vue-horizontal class="mb-3">
      <template v-slot:btn-prev>
        <feather-icon size="24" height="40" class="btn-left" icon="ChevronLeftIcon" />
      </template>
      <template v-slot:btn-next>
        <feather-icon size="24" height="40" class="btn-right" icon="ChevronRightIcon" />
      </template>
      <div @click="tabIndex = 0" :class="getTabClass(tabIndex, 0)">
        <feather-icon class="mr-1" icon="HomeIcon" />
        <span>
          {{ $t("Details") }}
        </span>
      </div>
      <div @click="tabIndex = 1" :class="getTabClass(tabIndex, 1)">
        <feather-icon class="m-1" icon="CalendarIcon" />
        <span>
          {{ $t("Calendar") }}
        </span>
      </div>
    </vue-horizontal>

    <b-tabs v-if="accommodation" no-fade v-model="tabIndex" class="accommodation-view" nav-wrapper-class="d-none">
      <b-tab active>
        <summary-card class="mb-4" />
        <distribution-card v-if="bedrooms.length || bathrooms.length" />
      </b-tab>

      <b-tab>
        <calendar-card :active="tabIndex === 1" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab } from "bootstrap-vue";
import SummaryCard from "@/views/accommodations/accommodation/components/SummaryCard.vue";
import DistributionCard from "@/views/accommodations/accommodation/components/DistributionCard.vue";
import CalendarCard from "@/views/accommodations/accommodation/components/CalendarCard.vue";
import VueHorizontal from "vue-horizontal";

export default {
  components: {
    BTabs,
    BTab,
    SummaryCard,
    DistributionCard,
    CalendarCard,
    VueHorizontal,
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  computed: {
    accommodation() {
      return this.$store.getters["accommodation/accommodation"];
    },
    bedrooms() {
      return this.$store.getters["accommodation/bedrooms"];
    },
    bathrooms() {
      return this.$store.getters["accommodation/bathrooms"];
    },
  },
  watch: {
    accommodation(accommodation) {
      this.setPageTitle(accommodation);
    },
  },
  created() {
    this.fetchAccommodation();
  },
  mounted() {
    this.setPageTitle(this.accommodation);
  },
  destroyed() {
    this.setPageTitle(null);
  },
  methods: {
    getTabClass(selectedIndex, index) {
      return `font-weight-bold pb-3 cursor-pointer px-3 ${selectedIndex === index ? "btn-active" : ""
        }`;
    },
    fetchAccommodation() {
      const { slug } = this.$route.params;

      if (slug === this.accommodation?.slug) {
        this.fetchAccommodationDetails();
        return;
      }
      this.$store.dispatch("app/setLoading", true);
      this.$store.dispatch("accommodation/reset");
      this.$store
        .dispatch("accommodation/fetchAccommodationBySlug", slug)
        .then(() => this.fetchAccommodationDetails())
        .catch(() =>
          this.$router.push({ name: "foravila-accommodations-list" })
        )
        .finally(() => this.$store.dispatch("app/setLoading", false));
    },
    fetchAccommodationDetails() {
      this.$store
        .dispatch("accommodation/fetchBedrooms", this.accommodation.uuid)
        .catch(() => { });
      this.$store
        .dispatch("accommodation/fetchBathrooms", this.accommodation.uuid)
        .catch(() => { });
      this.$store
        .dispatch("accommodation/fetchBookings", this.accommodation.uuid)
        .catch(() => { });
    },
    setPageTitle(accommodation) {
      this.$store.dispatch("app/setPageTitle", accommodation?.name || null);

      const cityText = accommodation?.location?.city || null;
      if (!cityText) {
        this.$store.dispatch("app/setPageSubtitle", null);
        return;
      }

      const foundIndex = cityText?.indexOf("(") || null;
      if (foundIndex === -1) {
        this.$store.dispatch("app/setPageSubtitle", cityText);
        return;
      }

      const subtitle = cityText
        ? cityText.substring(0, foundIndex - 1)
        : null;
      this.$store.dispatch("app/setPageSubtitle", subtitle);
    },
  },
};
</script>

<style lang="scss">
#accommodation-view {
  // Posam aquest min height perquè s'spinner mentre carrega informació quedi visible
  min-height: 200px;

  .v-hl-btn {
    top: -14px;
  }

  .btn-left {
    background: linear-gradient(to left, #ffffff00 0, #f8f8f8 50%, #f8f8f8);
  }

  .btn-right {
    background: linear-gradient(to right, #ffffff00 0, #f8f8f8 50%, #f8f8f8);
  }

  .btn-active {
    color: #ffcd00;
    border-bottom: 2px solid;
  }
}
</style>
